import actionTypes from 'SRC/modules/redux/actionTypes'

export const setElements = elements => ({
  type: actionTypes.SET_USERS_LIST_ELEMENTS,
  payload: elements
})
